import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "raskLinkifyFormat" })
export class StringLinkifyPipe implements PipeTransform {
    /**
     * Gör om urlar i en text  till ankar taggar t.ex. "läs mer på http:\\www.di.se." blir "läs mer på <a href="http:\\www.di.se" target="_blank">http:\\www.di.se.</a>"
     * Detta kan användas i markup tillsammans med <div [innerHTML]="text | raskLinkifyFormat: text"></div>
     *
     * @param plainText
     */
    transform(plainText: string): string {
        let replacedText;

        // URLs starting with http://, https://, or ftp://
        const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
        replacedText = plainText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        // eslint-disable-next-line sonarjs/single-char-in-character-classes
        const replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        // Change email addresses to mailto:: links.
        // eslint-disable-next-line sonarjs/duplicates-in-character-class, sonarjs/super-linear-regex
        const replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

        return replacedText;
    }
}
